<form [formGroup]="schoolUrlForm">
    <div formArrayName="urls">
        <p-table [value]="urlForms.controls">
            <ng-template pTemplate="header">
                <tr>
                    <th>URL</th>
                    <th>Delete</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-i let-index="rowIndex">
                <tr [formGroup]="i">
                    <td>
                        <input pInputText formControlName="url">
                    </td>
                    <td>
                        <p-button (onClick)="deleteUrl(i, index)" icon="pi pi-trash"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</form>
<p-button label="Add new" (onClick)="addUrlToFormArray()"></p-button>